import { AuthBindings } from "@refinedev/core";
import axiosInstance from "config/axios";

export const TOKEN_KEY = "refine-auth";

export const authProvider: AuthBindings = {
  login: async ({ username, password }) => {
    const response = await axiosInstance.post("/login", {
      username,
      password,
    });

    if (!response.data.error) {
      sessionStorage.setItem(TOKEN_KEY, response.data.token);
      localStorage.setItem(
        "identity",
        JSON.stringify({
          fullname: response.data.fullname,
          profile: response.data.profile,
        })
      );
      if (!response.data.permission) {
        localStorage.setItem("bussiness_id", "null");
        window.location.replace(`/onboarding/register`);
        console.log("not permission");
      } else {
        localStorage.setItem(
          "permission",
          JSON.stringify(response.data.permission)
        );
        localStorage.setItem(
          "bussiness_id",
          response.data.permission.app_able_type
        );
        localStorage.setItem(
          "bussiness_type",
          response.data.permission.app_able.type
        );
        if (response.data.permission.app_able.type === "TourActivity") {
          localStorage.setItem("tour_id", response.data.permission.app_able.id);
          localStorage.setItem(
            "org_id",
            response.data.permission.app_able.organization_id
          );
        }
        if (response.data.permission.app_able.type === "Shop") {
          localStorage.setItem("shop_id", response.data.permission.app_able.id);
        }
        if (response.data.permission.app_able.type === "Hotel") {
          localStorage.setItem(
            "hotel_id",
            response.data.permission.app_able.id
          );
        }
        if (response.data.permission.app_able.type === "Restaurant") {
          localStorage.setItem(
            "restaurant_id",
            response.data.permission.app_able.id
          );
        }
        window.location.replace("/");
      }

      return {
        success: true,
        redirectTo: "/",
      };
    }

    return {
      success: false,
      error: {
        name: "LoginError",
        message: "Invalid username or password",
      },
    };
  },
  register: async (payload) => {
    const response = await axiosInstance.post("/sign_up", {
      user: {
        ...payload,
      },
    });
    if (!response.data.error) {
      sessionStorage.setItem(TOKEN_KEY, response.data.token);
      localStorage.setItem("bussiness_id", "null");
      window.location.replace("/onboarding/register");
      return {
        success: true,
        redirectTo: "/onboarding/register",
      };
    }

    return {
      success: false,
      error: {
        message: "Invalid credentials",
        name: "Invalid credentials",
      },
    };
  },
  logout: async () => {
    // localStorage.removeItem(TOKEN_KEY);
    sessionStorage.clear();
    localStorage.clear();
    return {
      success: true,
      redirectTo: "/login",
    };
  },
  check: async () => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (token) {
      axiosInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;

      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },
  getPermissions: async () => null,
  getIdentity: async () => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    const identity = JSON.parse(localStorage.getItem("identity") || "{}");
    if (token) {
      return {
        id: 1,
        name: identity.fullname,
        avatar: identity?.profile?.asset,
      };
    }
    return null;
  },
  onError: async (error) => {
    console.error(error);
    return { error };
  },
};
